<template>
  <a-modal
    class="client-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    :title="title"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <a-form
      layout="horizontal"
      :form="form"
      style="margin-bottom:90px;"
    >
      <a-form-item
        label="企业"
        :colon="false"
        :label-col="{span:5}"
        :wrapper-col="{span:17}"
      >
        <a-select
          v-decorator="[
            'company_id',
            { rules: [{ required: true, message: '请选择企业' }] },
          ]"
          placeholder="请选择企业"
        >
          <a-select-option
            v-for="item in companyData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.team_name?item.team_name:item.companyInfo.qichacha_name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="调查问卷名称"
        :colon="false"
        :label-col="{span:5}"
        :wrapper-col="{span:17}"
      >
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入问卷名称',
                },
              ],
            },
          ]"
          placeholder="请输入问卷名称"
        />
      </a-form-item>
      <a-form-item
        label="调查问卷目的"
        :colon="false"
        :label-col="{span:5}"
        :wrapper-col="{span:17}"
      >
        <a-input
          v-decorator="[
            'aim',
            {
              rules: [
                {
                  required: true,
                  message: '请输入调查问卷目的',
                },
              ],
            },
          ]"
          placeholder="请输入调查问卷目的"
        />
      </a-form-item>
      <a-form-item
        label="调查问卷题目"
        :colon="false"
        :label-col="{span:5}"
        :wrapper-col="{span:17}"
      >
        <a-select
          v-decorator="[
            'question_ids',
            { rules: [{ required: true, message: '请选择调查问卷题目' }],},

          ]"
          placeholder="请选择调查问卷题目"
          mode="multiple"
        >
          <a-select-option
            v-for="item in questionData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.question }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <slot />
  </a-modal>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      questionData: [],
      companyData: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted(){
    // 获取问题
    this.getQuestionData();
    this.getCompanyData();
  },
  methods: {
    // 选择企业
    async getCompanyData(){
      let result = await this.$http.post(
        '/company/getCompanyList',
        {page: 0, pageSize: 0}
      );
      if(result.data.status===1){
        let data=result.data.data.data_list.filter((item)=>item.status===1);
        this.companyData=data;
      }
    },
    // 获取问题
    async getQuestionData(params) {
      let result = await this.$http.post('/QuestionBank/getList', params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list.filter((item)=>item.status===1);
        this.questionData=data;
      }
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
